/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export class Field {
  KEY: string;
  NAME: string;
  VALUE?: string;
  OPERAND?: Operand;
}

export class Filter {
  KEY: string;
  NAME?: string;
  VALUE: string;
  OPERAND: Operand;

  static parse(json: any): Filter {
    if (json) {
      const f = new Filter();

      f.KEY = json.KEY;
      f.VALUE = json.VALUE;
      f.OPERAND = Operand[<string>json.OPERAND];

      return f;
    } else return null;
  }

  static parseArray(json: any[]): Filter[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(Filter.parse(j));

    return arr;
  }
}

export class Order {
  KEY: string;
  NAME?: string;
  VALUE: OrderDirection;

  static parse(json: any): Order {
    if (json) {
      const o = new Order();

      o.KEY = json.KEY;
      o.VALUE = json.VALUE;

      return o;
    } else return null;
  }

  static parseArray(json: any[]): Order[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(Order.parse(j));

    return arr;
  }
}

export class Display {
  KEY: string;
  NAME?: string;

  static parse(json: any): Display {
    if (json) {
      const o = new Display();

      o.KEY = json.KEY;

      return o;
    } else return null;
  }

  static parseArray(json: any[]): Display[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(Display.parse(j));

    return arr;
  }
}

export class Query {
  FILTER: Filter[];
  DISPLAY: Display[];
  ORDER: Order[];
  NAME?: String[];
  CLIENT?: String[];

  static parse(json: any): Query {
    if (json) {
      const q = new Query();
      q.NAME = [];

      if (json.FILTER)
        q.FILTER = Filter.parseArray(json.FILTER);
      if (json.DISPLAY)
        q.DISPLAY = Display.parseArray(json.DISPLAY);
      if (json.ORDER)
        q.ORDER = Order.parseArray(json.ORDER);

      return q;
    } else return null;
  }
}

export enum Operand {
  LIKE = 'LIKE',
  EQUAL = 'EQUALS',
  LESS_THAN = 'LESS_THAN',
  GREATER_THAN = 'GREATER_THAN',
}

export enum OrderDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}
